export class MobilePhonePagarMe {
	country_code: string;
	area_code: string;
	number: string;

	constructor() {
	
	}
}